import SignIn from "../LoginSignUp/SignIn"
export default function Login(){
    return <SignIn/>
}